module.exports = __webpack_public_path__ + "static/media/paramLogo_01.3a82fb2d.svg";